import * as _ from "lodash";
import React from "react";
import { OptionTypeBase } from "react-select";

import { useStringArraySearchParam } from "../../../hooks";

interface Props {
  products: { brand: string }[];
}

function brandToOption(brand: string): OptionTypeBase {
  return {
    label: brand,
    value: brand.toLowerCase(),
  };
}

export default function BrandCheckboxGroup(props: Props & React.ComponentProps<"div">) {
  const { products, children, className, ...divProps } = props;
  const [filterBrands, filterBrandsActions] = useStringArraySearchParam("brands");

  const brandLookup = new Set<string>();
  const options: OptionTypeBase[] = [];

  (products ?? []).forEach(({ brand }) => {
    const value = brand.toLowerCase();

    if (!brandLookup.has(value)) {
      brandLookup.add(value);
      options.push(brandToOption(brand));
    }
  });

  const sortedOptions = options.sort((a, b) => a.value.localeCompare(b.value));

  return (
    <div {...divProps}>
      {sortedOptions.map(({ label, value }) => (
        <p className="is-block" key={value}>
          <label className="checkbox">
            <input
              type="checkbox"
              value={value}
              onClick={() =>
                filterBrands.indexOf(value) !== -1 ? filterBrandsActions.remove(value) : filterBrandsActions.add(value)
              }
              onChange={() => {}}
              checked={filterBrands.indexOf(value) !== -1}
            />{" "}
            {label}
          </label>
        </p>
      ))}
    </div>
  );
}
